import { render, staticRenderFns } from "./KvEditor.vue?vue&type=template&id=79d2c063&scoped=true&"
import script from "./KvEditor.vue?vue&type=script&lang=js&"
export * from "./KvEditor.vue?vue&type=script&lang=js&"
import style0 from "./KvEditor.vue?vue&type=style&index=0&id=79d2c063&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d2c063",
  null
  
)

export default component.exports